export default __webpack_public_path__ + "static/media/icona-calavera-comandament2.b8cf17e4.svg";